import CHECKOUT_OPTION from 'constants/checkoutOption.const';
import PAYMENT_TYPE from 'constants/paymentType.const';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isNotEnumVal from 'utils/predicates/enum/isNotEnumVal.util';
import isPositiveNumber from 'utils/predicates/number/isPositiveNumber.util';

const L = logger('determinePaymentType');

const determinePaymentType = L.wrap('()', (options) => {
  const { cardAmount, onlineAmount, isPosEnabled, checkoutOption } = asObject(options);

  const hasCardAmount = isPositiveNumber(cardAmount);
  const hasOnlineAmount = isPositiveNumber(onlineAmount);

  if (!hasCardAmount && !hasOnlineAmount) {
    return PAYMENT_TYPE.cash;
  }

  // NOTE: If there is no client or client has no card on file, dialog isn't shown so checkoutOption is not set
  const hasNoCardOnFile = isNotEnumVal(CHECKOUT_OPTION, checkoutOption);
  const isPosSelected = checkoutOption === CHECKOUT_OPTION.terminal;
  const isPosDisabled = !isPosEnabled;

  // can't do POS transaction if the cardAmount is not positive
  if (isPosEnabled && (isPosSelected || hasNoCardOnFile)) {
    return PAYMENT_TYPE.slickPos;
  }

  // NOTE: if there is card on file, it will be used instead of card at premises
  if (hasOnlineAmount) {
    return PAYMENT_TYPE.onlineCard;
  }

  // NOTE: if POS is enabled, can't pay with card, it's either one or the other
  if (isPosDisabled && hasCardAmount) {
    return PAYMENT_TYPE.card;
  }

  return PAYMENT_TYPE.cash;
});

export default determinePaymentType;
